var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcedures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Procedures"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4 15.35L8.65 11.6L16.95 3.3C17.15 3.1 17.3875 3 17.6625 3C17.9375 3 18.175 3.1 18.375 3.3L20.7 5.625C20.9 5.825 21 6.0625 21 6.3375C21 6.6125 20.9 6.85 20.7 7.05L12.4 15.35ZM12.4 12.5L18.6 6.325L17.675 5.4L11.5 11.6L12.4 12.5ZM11 21L13 19H22V21H11ZM5.075 21C4.30833 21 3.57083 20.85 2.8625 20.55C2.15417 20.25 1.53333 19.8333 1 19.3L7.625 12.7L10.225 15.3C10.4583 15.5333 10.6417 15.8 10.775 16.1C10.9083 16.4 10.975 16.7167 10.975 17.05C10.975 17.3833 10.9083 17.7042 10.775 18.0125C10.6417 18.3208 10.4583 18.5917 10.225 18.825L9.75 19.3C9.21667 19.8333 8.59583 20.25 7.8875 20.55C7.17917 20.85 6.44167 21 5.675 21H5.075ZM5.075 19H5.675C6.175 19 6.65833 18.9042 7.125 18.7125C7.59167 18.5208 8 18.25 8.35 17.9L8.825 17.425C8.925 17.325 8.975 17.2083 8.975 17.075C8.975 16.9417 8.925 16.825 8.825 16.725L7.625 15.525L4.225 18.9C4.35833 18.9333 4.5 18.9583 4.65 18.975C4.8 18.9917 4.94167 19 5.075 19Z",
    fill: "#9DA5BA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcedures);
export default __webpack_public_path__ + "static/media/procedures.91db299188205b6c79edeb65a4893da5.svg";
export { ForwardRef as ReactComponent };